import type { LoggerConfig } from './types';
import type { HandlerType } from '@datadog/browser-logs';
import type { Site } from '@datadog/browser-core';

export const DEFAULT_NAMESPACE = 'seamless-logger';

/**
 * Config key that enables debug mode for namespaces
 */
export const DEBUG_CONFIG = 'loggerDebugNamespaces';

/**
 * Allowed tenants List
 */
export const ALLOWED_TENANTS = ['seamless'];

/**
 * Datadog default config
 */

export const DATADOG_DEFAULT_CONFIG = {
  handler: 'http' as HandlerType,
  site: 'datadoghq.eu' as Site,
  forwardErrorsToLogs: false,
  sessionSampleRate: 100,
};

/**
 * Reads configurations from local storage available for users to enable features in the logger component
 * Supports currently only the 'loggerDebugNamespaces' config
 * @returns LoggerConfig, a config object with a string array holding the namespaces provided to enable the debug mode
 */
export function getConfig(): LoggerConfig {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return {
      debugNamespaces: [],
    };
  }

  const namespacesWithDebugEnabled = localStorage.getItem(DEBUG_CONFIG);
  return {
    debugNamespaces: namespacesWithDebugEnabled ? namespacesWithDebugEnabled.split(',') : [],
  };
}
